import api from "../http-request";
import apiConstants from "../apiConstant";

export const getSpaceList = async (params) =>
  api.get(apiConstants.GET_LIST_SPACE, { params });
export const getSpaceDetail = async (id) =>
  api.get(`/api/rental-spaces/detail/${id}/manage`);
export const updateSpaceDetails= async (id, data) =>
  api.post(`/api/admin/rental-spaces/update-info/${id}`, data, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  })
